export const ListQueryKey = 'activitySubActivityRecords';
export const DetailQueryKey = 'activitySubActivityRecord';
export const Urls = {
  selectUrl: '/subActiveRecord/list',
  updateUrl: '/subActiveRecord/update',
  deleteUrl: '/subActiveRecord/delete',
  createUrl: '/subActiveRecord/create',
  detailUrl: '/subActiveRecord/info'
};